module.exports = __webpack_public_path__ + "static/media/fo.1d0e9fb5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/fo.svg
// module id = 2091
// module chunks = 0